import { defineMessages } from "react-intl";

export const messages = defineMessages({
    loadMoreBundles: {
        id: "upload.general.load-more-bundles",
        defaultMessage: "Load more bundles",
    },
    uploadNewBundle: {
        id: "upload.general.upload-new-bundle",
        defaultMessage: "Upload new bundle",
    },
    downloadEmptyMetadata: {
        id: "upload.general.download-empty-metadata",
        defaultMessage: "Download empty metadata file",
    },
    uploadMetadata: {
        id: "upload.general.upload-metadata",
        defaultMessage: "Upload metadata",
    },
    upload: {
        id: "upload.general.upload",
        defaultMessage: "Upload",
    },
    reuploadMetadata: {
        id: "upload.general.reupload-metadata",
        defaultMessage: "Re-upload metadata",
    },
    viewUpdate: {
        id: "upload.general.view-update",
        defaultMessage: "View/update",
    },
    uploadedBy: {
        id: "upload.general.uploaded-by",
        defaultMessage: "Uploaded by {name}",
    },
    albumPreview: {
        id: "upload.general.album-preview",
        defaultMessage: "Album preview",
    },
    createAlbum: {
        id: "upload.general.create-album",
        defaultMessage: "Create album",
    },
    updateAlbum: {
        id: "upload.general.update-album",
        defaultMessage: "Update album",
    },
    uploadZip: {
        id: "upload.general.upload-zip",
        defaultMessage: "Upload zip",
    },
    reuploadZip: {
        id: "upload.general.reupload-zip",
        defaultMessage: "Re-upload zip",
    },
    confirmation: {
        id: "upload.general.confirmation",
        defaultMessage: "Confirmation",
    },
    complete: {
        id: "upload.general.complete",
        defaultMessage: "Complete",
    },
    instructionsUpload1: {
        id: "upload.instructions.upload-1",
        defaultMessage: `To upload a new album bundle, you must download the empty
 metadata file and fill in the fields of the spreadsheet.`,
    },
    instructionsUpload2: {
        id: "upload.instructions.upload-2",
        defaultMessage: "Once done, use the upload button to start the upload process.",
    },
    instructionsUpload3: {
        id: "upload.instructions.upload-3",
        defaultMessage: "To download the non-macro spreadsheet <link>click here</link>.",
    },
    instructionsCreateAlbum1: {
        id: "upload.instructions.create-album-1",
        defaultMessage: "Below is a preview of the album that will be created.",
    },
    instructionsCreateAlbum2: {
        id: "upload.instructions.create-album-2",
        defaultMessage: `Check carefully that all information is as expected and
 pay close attention as to whether artists will be created.`,
    },
    instructionsCreateAlbum3: {
        id: "upload.instructions.create-album-3",
        defaultMessage: "If the above looks correct, click the button below create the album and artists, if relevant.",
    },
    instructionsUploadZip1: {
        id: "upload.instructions.upload-zip-1",
        defaultMessage: "Next you need to upload a zip file containing the following files:",
    },
    instructionsUploadZipList1: {
        id: "upload.instructions.upload-zip-list-1",
        defaultMessage: `A JPG or PNG file for the artwork. Typically this should be a 3000x3000 RGB JPG file.
 Note: this can't contain embedded profiles.`,
    },
    instructionsUploadZipList2: {
        id: "upload.instructions.upload-zip-list-2",
        defaultMessage: `A FLAC or WAV file for each track on the release.
 The filename must be prefixed with <strong>''[disc]_[track]_''</strong>
 so they can be matched to the corresponding track. eg the audio for track 4 on
 disc 2 might have the filename <strong>''2_4_tracktitle.wav''</strong>.`,
    },
    instructionsUploadZipList3: {
        id: "upload.instructions.upload-zip-list-3",
        defaultMessage: "An optional PDF file for the booklet.",
    },
    instructionsComplete1: {
        id: "upload.instructions.complete-1",
        defaultMessage: `To complete the upload of the bundle and create the album,
 you just need to confirm that you want to continue. Once done, the audio will begin
 to be processed so this could take some time.`,
    },
    instructionsComplete2: {
        id: "upload.instructions.complete-2",
        defaultMessage: "Note",
    },
    instructionsComplete3: {
        id: "upload.instructions.complete-3",
        defaultMessage: `The complete action is final and, once done, you won't
 be able to return to previous steps to re-upload metadata nor content. Click to
 complete once you're sure everything is as expected. Also give plenty of time
 for the album to be sent to the DSPs, typically at least a week before release.`,
    },
    instructionsError1: {
        id: "upload.instructions.error-1",
        defaultMessage: `The bundle is in an error state after the last action.
 Please contact support to resolve the issues.`,
    },
    instructionsError2: {
        id: "upload.instructions.error-2",
        defaultMessage: `The following errors were reported:`,
    },
    // Bundle entity
    bundleDefaultTitle: {
        id: "upload.bundle.default-title",
        defaultMessage: "Bundle {id}",
    },
    bundleEntitySingular: {
        id: "upload.bundle.entity_singular",
        defaultMessage: "Bundle",
    },
    bundleEntityPlural: {
        id: "upload.bundle.entity_plural",
        defaultMessage: "Bundles",
    },
    bundleEntityDefiniteArticle: {
        id: "upload.bundle.entity_definite_article",
        defaultMessage: "the bundle",
    },
    bundleEntityDemonstrative: {
        id: "upload.bundle.entity_demonstrative",
        defaultMessage: "this bundle",
    },
    bundleEntityIndefiniteArticle: {
        id: "upload.bundle.entity_indefinite_article",
        defaultMessage: "a bundle",
    },
    bundleColumnAttrs: {
        id: "upload.bundle.columns.attrs",
        defaultMessage: "Attributes",
    },
    bundleColumnErrors: {
        id: "upload.bundle.columns.errors",
        defaultMessage: "Errors",
    },
    bundleColumnStatus: {
        id: "upload.bundle.columns.status",
        defaultMessage: "Status",
    },
    bundleColumnAlbum: {
        id: "upload.bundle.columns.album",
        defaultMessage: "Album",
    },
    bundleColumnUser: {
        id: "upload.bundle.columns.user",
        defaultMessage: "Uploaded by",
    },
    bundleColumnCreatedAt: {
        id: "upload.bundle.columns.created_at",
        defaultMessage: "Created",
    },
    bundleColumnUpdatedAt: {
        id: "upload.bundle.columns.updated_at",
        defaultMessage: "Updated",
    },
});
